type pepQuestions = {
  isPoliticallyExposed: boolean
  politicallyExposedByRelative: boolean
}

export type PEP = Nullable<{
  positionHeld: string
  relativeName: string
  relativePositionHeld: string
  relativeRelation: string
}> &
  pepQuestions

function load(model?: Partial<PEP> | null): PEP {
  return {
    isPoliticallyExposed: model?.isPoliticallyExposed ?? false,
    politicallyExposedByRelative: model?.politicallyExposedByRelative ?? false,
    relativeName: model?.relativeName ?? null,
    positionHeld: model?.positionHeld ?? null,
    relativePositionHeld: model?.relativePositionHeld ?? null,
    relativeRelation: model?.relativeRelation ?? null,
  }
}

const questions: Record<
  keyof pepQuestions,
  { question: string; hint?: string; enableSections?: ('pep-info' | 'pep-relative-info')[] }
> = {
  isPoliticallyExposed: {
    question: '¿Es usted una Persona Expuesta Políticamente (PEP)?',
    hint: 'Persona que en los últimos 3 años ha tenido un cargo público importante —como funcionario, juez, militar o representante de gobierno— o tiene familiares cercanos que lo hayan tenido.',
    enableSections: ['pep-info'],
  },
  politicallyExposedByRelative: {
    question: '¿Es usted familiar de una Persona Expuesta Políticamente (PEP)?',
    enableSections: ['pep-relative-info'],
  },
}

const map = {
  toCumplimientoViewModel(model: PEP): SiteApiSchema<'CumplimientoViewModel`3'> {
    return {
      esPep: model.isPoliticallyExposed,
      esParientePep: model.politicallyExposedByRelative,
      pepPariente: {
        nombreCompleto: model.relativeName,
        cargo: model.relativePositionHeld,
        parentescoFuncionario: model.relativeRelation,
      },
      pep: {
        cargo: model.positionHeld,
      },
    }
  },
}

export const PEP = {
  load,
  map,
  questions,
}
